'use client'

import { PageLayout } from '~/components/component-library'
import { EmptyState } from '~/components/component-library/EmptyState'

/**
 * Use with withOrgAccess to display a message when the user does not have access to the page.
 * Uses PageLayout so the page has a sidebar.
 */
export function UnauthorizedPage({
  customTitle = 'Access Denied',
  customMessage = 'You do not have permission to access this page.',
}: {
  customMessage?: string
  customTitle?: string
}) {
  return (
    <PageLayout>
      <EmptyState title={customTitle}>{customMessage}</EmptyState>
    </PageLayout>
  )
}
